import React, { createContext, useEffect, useState } from 'react'

const ThemeContext = createContext(null)

export const ThemeProvider = ({ children }) => {
  const theme = localStorage.getItem('theme')
  const themeOnReload =
    theme === 'light' ? true : theme === 'dark' ? false : true
  const [lightMode, setLightMode] = useState(themeOnReload)
  return (
    <ThemeContext.Provider value={{ lightMode, setLightMode }}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeContext
